export default function GeneralIcon() {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4264_12909)">
        <path
          d="M11.3844 20.9914C9.92822 20.9914 8.47079 20.9914 7.01218 20.9914C6.25908 20.9914 6.05564 20.7801 6.05475 20.0006C6.05475 17.8549 6.04582 15.7093 6.05475 13.5637C6.06545 11.3847 7.45655 9.94066 9.55167 9.9249C10.7848 9.91563 12.0189 9.91193 13.252 9.9249C15.2749 9.94807 16.6802 11.3773 16.7017 13.4682C16.724 15.6759 16.7097 17.8837 16.7017 20.0905C16.7017 20.7495 16.4714 20.9867 15.8352 20.9895C14.3567 20.996 12.8701 20.9914 11.3844 20.9914Z"
          fill="white"
        />
        <path
          d="M15.3391 4.99109C15.298 7.32858 13.5304 9.12017 11.3077 9.07753C10.7868 9.06974 10.2726 8.95471 9.79489 8.7391C9.31714 8.52349 8.88531 8.21159 8.52439 7.82145C8.16348 7.43131 7.88066 6.97068 7.6923 6.46623C7.50394 5.96178 7.41379 5.42354 7.42706 4.88265C7.469 2.63043 9.30089 0.787872 11.4353 0.848116C13.6339 0.906507 15.3792 2.76019 15.3391 4.99109Z"
          fill="white"
        />
        <path
          d="M5.17958 20.9351C4.0758 20.9351 3.00683 20.9861 1.94499 20.9184C1.14192 20.8674 0.405778 20.1436 0.370978 19.2751C0.306733 17.6763 0.261226 16.0581 0.425409 14.4722C0.589592 12.8864 1.93339 11.8029 3.45923 11.7399C4.07848 11.714 4.69863 11.7353 5.26881 11.7353C4.97435 14.6817 5.16441 17.5966 5.13407 20.506C5.14097 20.6498 5.15617 20.7931 5.17958 20.9351Z"
          fill="white"
        />
        <path
          d="M17.7387 20.9666C17.6656 17.883 17.9047 14.8207 17.5781 11.6787C18.3928 11.7297 19.2521 11.6787 20.0659 11.8576C21.5355 12.1764 22.5268 13.5639 22.5357 15.1238C22.5438 16.3435 22.5411 17.5632 22.5357 18.7829C22.5357 20.0193 21.854 20.8646 20.6771 20.9517C19.6911 21.025 18.6953 20.9666 17.7387 20.9666Z"
          fill="white"
        />
        <path
          d="M4.77931 10.8414C4.1952 10.8416 3.62414 10.6621 3.13819 10.3254C2.65225 9.98877 2.2732 9.51014 2.04891 8.94994C1.82461 8.38973 1.76511 7.77307 1.87793 7.17777C1.99074 6.58248 2.2708 6.03524 2.68277 5.60513C3.09474 5.17502 3.62014 4.88131 4.19267 4.76109C4.76519 4.64086 5.35917 4.6995 5.89964 4.92961C6.4401 5.15972 6.90283 5.55098 7.22941 6.05401C7.55599 6.55703 7.73178 7.14928 7.73461 7.75599C7.74058 8.16156 7.66833 8.56427 7.52212 8.94039C7.37591 9.3165 7.15869 9.65841 6.88328 9.94595C6.60786 10.2335 6.27981 10.4609 5.91846 10.6147C5.55712 10.7685 5.16979 10.8456 4.77931 10.8414Z"
          fill="white"
        />
        <path
          d="M21.0354 7.76506C21.0363 8.37193 20.864 8.96547 20.5404 9.47071C20.2167 9.97595 19.7561 10.3702 19.2169 10.6038C18.6776 10.8373 18.0838 10.8997 17.5105 10.7829C16.9371 10.6662 16.41 10.3755 15.9955 9.94777C15.5811 9.52001 15.298 8.97427 15.1819 8.37948C15.0659 7.7847 15.1221 7.16753 15.3436 6.60593C15.565 6.04433 15.9417 5.56347 16.426 5.22408C16.9104 4.8847 17.4807 4.702 18.065 4.69907C18.4551 4.693 18.8424 4.76802 19.2042 4.9197C19.566 5.07139 19.895 5.29669 20.1717 5.58234C20.4485 5.868 20.6675 6.20826 20.8158 6.5831C20.9641 6.95794 21.0388 7.35981 21.0354 7.76506Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4264_12909">
          <rect
            width="22.2298"
            height="20.1458"
            fill="white"
            transform="translate(0.310547 0.847168)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
